var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"appendToBody":false,"title":_vm.title,"size":"large_large"}},[_c('div',{staticClass:"mw-margin-top-10 process-dialog"},[_c('MwFlowInterferingTable',{attrs:{"filterParams":_vm.params}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5b8c583b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/components/public-dialog/process-interfering.vue
// module id = 1147
// module chunks = 0 1